import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import InputField from '../input-field';
import Editor from '../editor/';
import LoadingAnimation from '../loading-animation';
import { getPage, editPage } from "../../api/";
import debounce from 'lodash.debounce';
import './content-page.scss';

const ContentPage = ({ id, title}) => {
	const [isLoading, setIsLoading] = useState(true);
	const [isSaving, setIsSaving] = useState(false);
	const [pageState, setPageState] = useState({
		name: '',
		content: ''
	});

	function updatePageState(newState) {
		setPageState(prevState => {
			const newVal = {
	        ...prevState,
	        ...newState
	    };
			return newVal;
		});
	};

	useEffect(() => {
		console.log('pageState', pageState);
	});

	useEffect(() => {
		async function getPageData() {
			const pageData = await getPage(id);
			updatePageState(pageData);
			setIsLoading(false);
		}
		getPageData();
	}, [id]);

	function handleEditorChange (content) {
		updatePageState({content: content});
	}

	async function handleSave () {
		setIsSaving(true);
		console.log('pageState', pageState);
		await editPage(pageState);
		setIsSaving(false);
	}

	return (
		<div className="admin-app-page">
			{isSaving && <LoadingAnimation text="Saving..." showMask /> }
			{isLoading && !isSaving && <LoadingAnimation text="One moment, please..." showMask /> }
			<div className="page-editor">
				<div className="label-with-actions col-layout content-page-header">
					<div className="label">
						<h1>{pageState.name} Page Editor</h1>
					</div>
					<div className="actions content-page-actions">
						<button className="primary" onClick={() => {handleSave()}}>Submit</button>
					</div>
				</div>
				<InputField
					id="name"
					label="Page Title"
					onChange={(evt) => {
						updatePageState({name: evt.target.value});
					}}
					placeholder="Enter a page name"
					value={pageState.name}
				/>
				<div className="editor-wrap">
					<div className="form-element">
						<h2>{pageState.name} Page Content</h2>
						<Editor
							context="content-page"
							data={pageState.content}
							onInit={() => {
							}}
							onChange={debounce(content => { handleEditorChange(content); }, 600)}
						/>
					</div>
				</div>
			</div>
		</div>
	)
};

ContentPage.propTypes = {
	id: PropTypes.string,
	title: PropTypes.string
}

export default ContentPage
